"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReadinessCheck = useReadinessCheck;
var _react = require("react");
var _reactRedux = require("react-redux");
var _underscore = require("underscore");
var _actions = require("../../actions");
var _ReadinessCheck = require("../../constants/ReadinessCheck");
var _logger = require("@studio/logger");
/**
 * @description Hook to check the readiness of the presenter before starting the meeting
 * @returns {{sandboxMeetingStatus, handleContinueButtonClick, handleRetry, handleCreateSandbox}}
 */
function useReadinessCheck(_ref, _ref2) {
  var sandboxMeetingSession = _ref.sandboxMeetingSession,
    sandboxMeetingStatus = _ref.sandboxMeetingStatus;
  var startLoadReadinessCheckerSLI = _ref2.startLoadReadinessCheckerSLI,
    endLoadReadinessCheckerSLI = _ref2.endLoadReadinessCheckerSLI;
  var isBroadcastValid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var dispatch = (0, _reactRedux.useDispatch)();
  var user = (0, _reactRedux.useSelector)(function (state) {
    return state.user;
  });
  (0, _react.useEffect)(function () {
    if ((0, _underscore.isEmpty)(sandboxMeetingSession) && isBroadcastValid) {
      var userFullName = [user === null || user === void 0 ? void 0 : user.firstName, user === null || user === void 0 ? void 0 : user.lastName].filter(Boolean).join(' ');
      dispatch((0, _actions.createSandboxMeeting)({
        startLoadReadinessCheckerSLI: startLoadReadinessCheckerSLI,
        userNameInitials: (0, _logger.getNameInitials)(userFullName),
        endLoadReadinessCheckerSLI: endLoadReadinessCheckerSLI
      }));
    }
  }, [dispatch, user, isBroadcastValid]);
  function removeSandboxAttendee() {
    dispatch((0, _actions.removeSandboxMeetingAttendee)());
  }
  function retry() {
    dispatch((0, _actions.setReadinessCheck)({
      camera: _ReadinessCheck.CHECKING,
      microphone: _ReadinessCheck.CHECKING
    })); // Reset the readiness check
    dispatch((0, _actions.runReadinessCheck)(undefined, true));
  }
  function createSandbox() {
    dispatch((0, _actions.createSandboxMeeting)());
  }
  function start() {
    dispatch((0, _actions.runReadinessCheck)());
  }
  return {
    retry: retry,
    start: start,
    removeSandboxAttendee: removeSandboxAttendee,
    createSandbox: createSandbox,
    sandboxMeetingStatus: sandboxMeetingStatus
  };
}